import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "user-settings"
}

import {getSliceComponentProps} from '@prismicio/vue';
    import {inject, computed} from 'vue';
    import {MEDIA_BREAKPOINTS} from '@/unlogged/keys';
    import {UserSettingsSliceSlice} from '@/unlogged/prismicio';
    import UserSettingsControls from '@/unlogged/components/UserSettingsControls.vue';
    import {useUserInfoHelpers, Dropdown} from '@malt/vue-prismic';
    import {useUserData} from '@/unlogged/composables/useUserData';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: getSliceComponentProps<UserSettingsSliceSlice>(),
  setup(__props) {

    

    const userDataState = useUserData();
    const userData = computed(() => userDataState?.value?.data);
    const breakpoints = inject(MEDIA_BREAKPOINTS);
    const {isUserInfo} = useUserInfoHelpers();

return (_ctx: any,_cache: any) => {
  const _component_joy_icon = _resolveComponent("joy-icon")!

  return (_unref(userData) && _unref(isUserInfo)(_unref(userData).info) && _unref(userData).info.firstName !== null)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        (!_unref(breakpoints)?.isTablet)
          ? (_openBlock(), _createBlock(_unref(Dropdown), {
              key: 0,
              id: "user-settings",
              class: "settings-button",
              "menu-class": "settings-dropdown"
            }, {
              header: _withCtx(() => [
                _createVNode(_component_joy_icon, {
                  name: "settings-outline",
                  clickable: ""
                })
              ]),
              content: _withCtx(() => [
                _createVNode(UserSettingsControls, {
                  slice: _ctx.slice,
                  "user-data": _unref(userData)
                }, null, 8, ["slice", "user-data"])
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(UserSettingsControls, {
              key: 1,
              slice: _ctx.slice,
              "user-data": _unref(userData)
            }, null, 8, ["slice", "user-data"]))
      ]))
    : _createCommentVNode("", true)
}
}

})